import { render, staticRenderFns } from "./expertFeedbackIndex.vue?vue&type=template&id=24e9ffb6&scoped=true"
import script from "./expertFeedbackIndex.vue?vue&type=script&lang=js"
export * from "./expertFeedbackIndex.vue?vue&type=script&lang=js"
import style0 from "./expertFeedbackIndex.vue?vue&type=style&index=0&id=24e9ffb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9ffb6",
  null
  
)

export default component.exports